import useSWR from 'swr'
import { useAuth } from '../store/auth.store'
import { PermissionService } from '../services/permissions.service'
import { useNotify } from '../provider/NotifyProvider'

const fetchData = async (
  userId: string | number,
): Promise<IPermission[]> => {
  return await PermissionService.getPermissions(userId)
}

const useDataPermission = () => {
  const { user } = useAuth()
  const {onSuccessNotify, onErrorNotify} = useNotify()
  const { data, error, isLoading, mutate } = useSWR<IPermission[]>(
    `/client/permissions/${user?.id}`,
    () => fetchData(user?.id!)
  )

  const update = async (id:number, field: string, value: boolean) => {
    if(id === 99999999999) return
    await PermissionService.updatePermission(id,field,value)
    mutate()
  }

  const create = async (user: IUser, title: string, color:string, obj:IPermission) => {
    await PermissionService.createPermission(user,title,color,obj)
    mutate()
  }

  const deletePermission = async (id: number) => {
      const res = await PermissionService.deletePermission(id)
      console.log(res.status)
      if(res.status === 500){
        onErrorNotify('קיים עובד אחד לפחות שקשור להרשאה זו, אנא מחק את ההרשאות הקשורות')
        return
      }
      onSuccessNotify('ההרשאה נמחקה בהצלחה')
      mutate()
  }

  const updatePermission = async (obj: IPermission) => {
    await PermissionService.updateMainPermission(obj)
    mutate()
  }

  return {
    data,
    isLoading: isLoading,
    isError: error,
    update,
    create,
    mutate,
    deletePermission,
    updatePermission
  }
}

export default useDataPermission

